import { z } from 'zod';

const booleanCoerceSchema = z.preprocess((val) => {
  if (typeof val === 'string') {
    if (val.toLowerCase() === 'true') return true;
    if (val.toLowerCase() === 'false') return false;
  }
  return val;
}, z.boolean());

export const envSchema = z.object({
  envName: z
    .enum(['production', 'development', 'local'])
    .optional()
    .default('development'),
  appName: z.coerce.string().optional().default('Omecare'),
  api: z.object({
    url: z.coerce.string().optional().default('http://localhost:3001'),
    mock: booleanCoerceSchema.optional().default(false),
  }),
  feature: z.object({
    doctorSubstituteContracts: booleanCoerceSchema.optional().default(true),
    dazzImportMock: booleanCoerceSchema.optional().default(false),
  }),
  sentry: z.object({
    enabled: booleanCoerceSchema.optional().default(true),
  }),
});

export type Env = z.infer<typeof envSchema>;

class EnvService {
  public readonly env: Env;

  constructor() {
    const env = {
      envName: import.meta.env.VITE_MODE,
      appName: import.meta.env.VITE_APP_NAME,
      api: {
        url: import.meta.env.VITE_API_URL,
        mock: import.meta.env.VITE_API_MOCK,
      },
      feature: {
        doctorSubstituteContracts: import.meta.env
          .VITE_FEATURE_DOCTOR_SUBSTITUTE_CONTRACTS,
        dazzImportMock: import.meta.env.VITE_DAZZ_IMPORT_MOCK,
      },
      sentry: {
        enabled: import.meta.env.VITE_MODE !== 'local',
      },
    };
    this.env = envSchema.parse(env);
  }
}
export default new EnvService();
